import { IFrameWrapper } from "components/FrameWrapper/IFrameWrapperProps";
import React, { SyntheticEvent, useEffect, useRef, useState } from "react";

const FrameWrapper: React.FC<IFrameWrapper> = ({ id, src, title, scrolling = "no", frameBorder = "0", className = "" }) => {
	// utilizzato UseRef perchè tiene memoria dello stato del componente a differenza di createRef che va a ricrearl odi volta in volta
	const ref = useRef<HTMLIFrameElement>(null);
	const [height, setHeight] = useState("0px");
	const onLoad = (event: SyntheticEvent<Element, Event>) => {
		// Utilizzato event.currentTarget al posto di ref in quanto viene valorizzato solo alla fine del primo caricamento del componenete
		let myRef = event.currentTarget as HTMLIFrameElement;
		if (myRef) {
			setHeight(myRef.contentWindow?.document.body.scrollHeight + "px");
		}
	};

	//rende l' altezza dell'Iframe responsive
	useEffect(() => {
		var height = ref?.current?.contentWindow?.document.body?.scrollHeight;
		if (height) setHeight(height + "px");
	}, [ref?.current?.contentWindow?.document.body?.scrollHeight]);

	return (
		<>
			<iframe
				title={title}
				ref={ref}
				onLoad={onLoad}
				id={id}
				width="100%"
				height={height}
				onSuspendCapture={() => alert("ciao")}
				scrolling={scrolling}
				frameBorder={frameBorder}
				className={`custom-footer-iframe ${className}`}
				src={src}
			></iframe>
		</>
	);
};
export default FrameWrapper;
